<template>
  <!-- ホルター心電図解析 判定結果入力 -->
  <div id="HolterAnalysisApprovalDetail">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図解析 判定結果入力</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>受付番号</th><td>{{data.receiptNumber}}<span v-if="data.depositMachineFlag" class="depo"/></td></tr>
            <tr><th>返却希望日</th><td>{{data.returnDate}}</td></tr>
            <tr><th>解析日</th><td>{{data.analysisDay}}</td></tr>
            <tr v-if="!data.holterRequestId"><th>解析方法</th><td>{{data.analysisMethod | choiceFilter(analysisMethodList)}}</td></tr>
            <tr v-if="data.holterRequestId"><th>解析方法</th><td>ホルター心電図</td></tr>
            <tr><th>解析オプション</th><td>{{data.analysisOption | choiceFilter(analysisOptionList)}}</td></tr>
            <tr><th>CVHRI</th><td>{{ data.cvhri == -1 ? '算出不可' : data.cvhri }}</td></tr>
            <tr><th>AFの有無</th><td>{{ data.af == 1 ? '有' : '無' }}</td></tr>
            <tr><th style="vertical-align:top;">備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.receptionNote}}</div></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">メモ</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.memo}}</div></td>
            </tr>
            <tr>
              <th>解析レポート</th>
              <td v-if="resultFiles.length > 0" colspan="2">
                <ul>
                  <li v-for="(file,index) of resultFiles" :key="index">
                    <template v-if="!fileReplaceFlag || file.fileType == 8">
                      <a @click="downloadFile(file.path, file.fileId)"><b-icon icon="paperclip" />{{file.name}}</a>
                      <span v-if="file.staffDLFlag" class="download"></span>
                    </template>
                  </li>
                </ul>
              </td>
              <td v-else>
                ダウンロード期限切れです
              </td>
            </tr>
            <template v-if="status == 111 || fileReplaceFlag">
              <tr>
                <th>判定<span class="require" /></th><td>
                <div class="block 3 edit" validate="radioRequire" :name="'判定'">
                  <b-radio v-model="judgmentResult" native-value="A" @input="judgmentMemo = ''">A：異常なし</b-radio>
                  <b-radio v-model="judgmentResult" native-value="B" @input="judgmentMemo = ''">B：軽度以上</b-radio>
                  <b-radio v-model="judgmentResult" native-value="C" @input="judgmentMemo = ''">C：要観察</b-radio>
                  <b-radio v-model="judgmentResult" native-value="D" @input="judgmentMemo = ''">D：要精査</b-radio>
                  <b-radio v-model="judgmentResult" native-value="E" @input="judgmentMemo = ''">E：要治療</b-radio>
                </div></td>
              </tr>
              <tr v-if="judgmentResult">
                <th></th>
                <td style="display: grid; grid-template-columns: 1fr; justify-items: start;">
                  <template v-for="(sentence, index) in judgmentTemplates">
                    <b-radio
                      v-if="sentence.value === judgmentResult"
                      :key="index"
                      class="cstmCheckBox"
                      style="margin: 5px 0 !important;"
                      :value="selectedJudgmentTemplate"
                      :native-value="sentence.text"
                      @input="toggleRadio(sentence.text)"
                    >
                      {{ sentence.text }}
                    </b-radio>
                  </template>
                </td>
              </tr>
              <tr>
                <th>フリーコメント<span class="require" /></th>
                <td><textarea class="edit" validate="required" :name="'フリーコメント'" v-model="judgmentMemo" maxlength="256" style="resize:vertical;max-width:100%;min-height: 80px;"></textarea></td>
              </tr>
            </template>
            <template v-if="status !== 111 && !fileReplaceFlag">
              <tr><th>判定</th><td>{{judgmentResult}}</td></tr>
              <tr>
                <th style="vertical-align:top;">フリーコメント</th>
                <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{judgmentMemo}}</div></td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <div class="button-area" v-if="status == 111 && !fileReplaceFlag">
        <b-button class="receptionistButton is-primary" @click="save">更新</b-button>
        <b-button class="receptionistButton is-primary" @click="approval">承認</b-button>
      </div>
      <div class="button-area" v-if="fileReplaceFlag">
        <b-button class="receptionistButton is-primary" @click="replaceApproval">再判定承認</b-button>
      </div>
      <div style="height:5px;" />
      <div class="labelTitle lable">申込内容</div>
      <div id="item-contens">
        <holterAnalysisRequestDetail v-if="hasDetailData" v-bind:data="detailData" :canDownload="true" :editFlag="false" :hstRequestId="data.holterRequestId" :belongsNote="data.belongsNote" :isInternalPsg="true" />
      </div>
      
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import holterAnalysisRequestDetail from "@/components/mock/common/HolterAnalysisRequestDetail";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import {UploadType} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";

export default {
  name: "HolterAnalysisApprovalDetail",
  methods: {
    getReceptionData: function() {
      var excuteApi = this.getHolterAnalysisResultDetailPOST;
      var successCallBack = this.getHolterAnalysisResultDetailPOSTSuccess;
      var errorCallBack = this.getHolterAnalysisResultDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisResultDetailPOST: function(client) {
      return client.apis.externalHolterAnalysis.getHAnalysisResultDetailExternalPOST({
        body:{receiptNumber: this.receiptNumber}
      });
    },
    getHolterAnalysisResultDetailPOSTSuccess: function(result) {

      this.data = result.obj
      this.data.af = this.data.afKind
      
      this.version = this.data.version
      this.resultVersion = this.data.resultVersion

      //検索結果に表示されてから、詳細画面を押下される間にPSCチームなどでデータが更新されていた時の排他制御
      if(!this.isInitialCheckDone){
        if(this.resultVersion !== this.paramsResultVersion){
          this.showErrorMessage("他のユーザーによって変更された可能性があるため、更新を中断しました。")
          this.back();
          return;
        }
      }
      this.isInitialCheckDone = true

      this.data.af = this.data.afKind
      this.uploadFileName = this.data.patientId + "_" + this.data.requestDate + "_" + this.data.hospitalName + "_" + this.data.patientName + "様"
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g,'_')

      this.judgmentResult = this.data.judgmentResult
      this.judgmentMemo = this.data.judgmentMemo
      this.status = this.data.status
      this.fileReplaceFlag = this.data.fileReplaceFlag
      if(this.fileReplaceFlag){
        this.showMessage("こちらはファイル差替中案件となります。<br>PSCチームからの作業指示を確認の後ご対応をお願い致します。");
      }
    },
    getRequestDetailFiles: async function() {
      let _this = this;
      // Web Api Call
      this.apiAnsyncCall(
        function(client){
          return client.apis.internalRequestSearch.getRequestDetailFilesPOST({
            body:{receiptNumber:_this.receiptNumber}
          });
        },
        function(result) {
          _this.resultFiles = result.obj.resultFiles;       
        },
        function(result) {
        }
      );
    },

    getDetail: function() {
      var excuteApi = this.getAnalysisDetailPOST;
      var successCallBack = this.getAnalysisDetailPOSTSuccess;
      var errorCallBack = this.getAnalysisDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalHolterAnalysis.getHAnalysisRequestDetailExternalPOST({
        body:{receiptNumber: this.receiptNumber}
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      var res = result.obj
      this.detailData = res.applicationDetails
      this.detailData.patientName = this.detailData.patientName.replace( ' ', '　' );
      this.showDetail = true;

      this.upFiles = res.analysisResultFileList
      this.hasDetailData = true
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    back: function() {
      this.$router.push({
        name: "HolterAnalysisJudgment",
        params: { searchConditions: this.searchParams },
      });
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress,
              updFileInfoFlg: false
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    approval: function() {
      var elements = document.getElementsByClassName("edit");
      var result = this.selfMadeValidation(elements);
      if(result.isError) {
        this.showErrorMessage(result.msg)
        return
      }
      var messsage = `判定：${this.judgmentResult}<br><br>フリーコメント：${this.judgmentMemo.replace(/\r?\n/g, '<br>')}<br><br>判定内容がが正しいことを確認してください。<br>判定結果を承認してよろしいでしょうか？`;

      this.$dialog.confirm({
        title: "承認確認",
        message: messsage,
        confirmText:"はい",
        cancelText: "いいえ",
        onConfirm: async() => {
          // 承認する
          var excuteApi = this.setHolterJudgmentResultPOST;
          var successCallBack = this.setHolterJudgmentResultPOSTSuccess;
          var errorCallBack = this.setHolterJudgmentResultPOSTError;
          // Web Api Call
          this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      });
    },
    setHolterJudgmentResultPOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber, // 申込みID
        resultVersion: this.resultVersion, // バージョン
        judgmentResult: this.judgmentResult, // 判定
        judgmentMemo: this.judgmentMemo, // フリーコメント
      });
      return client.apis.externalHolterAnalysis.setHolterJudgmentResultPOST({
        body:obj
      });
    },
    setHolterJudgmentResultPOSTSuccess: async function(result) {
    // ホルター患者レポート生成
      this.generateKanjaReportPDF(result);
    },
    setHolterJudgmentResultPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    save: function(client) {
      var excuteApi = this.tempSaveResultPOST;
      var successCallBack = this.tempSaveResultPOSTSuccess;
      var errorCallBack = this.tempSaveResultPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    tempSaveResultPOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber,
        judgmentResult: this.judgmentResult, // 判定
        judgmentMemo: this.judgmentMemo, // フリーコメント
        resultVersion: this.resultVersion, // バージョン
      });
      return client.apis.externalHolterAnalysis.tempSaveHolterJudgmentResultPOST({
        body:obj
      });
    },
    tempSaveResultPOSTSuccess: async function(result) {
      // 解析結果承認詳細取得
      this.getReceptionData()
      // 申込内容取得
      this.getDetail()
      this.showSuccess(result)
    },
    tempSaveResultPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    generateKanjaReportPDF: function(result) {
      const _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalHolterAnalysis.getHolterReportPDFPOST({
            body:{
              receiptNumber: _this.receiptNumber,
              fileType: _this.UploadType.holter_patient_report,
              requestDate: _this.data.requestDate
            }
          });
        },
        function() {
          // 成功時
           _this.generateHanteiPDF(result);
        },
        function() {
          // エラー時
          result.obj.message += '\n\n※患者レポート生成に失敗しました。';
          _this.generateHanteiPDF(result);
        }
      );
    },
    generateHanteiPDF: function(result) {
      const _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalHolterAnalysis.getHolterReportPDFPOST({
            body:{
              receiptNumber: _this.receiptNumber,
              fileType: _this.UploadType.holter_judgment_report,
              requestDate: _this.data.requestDate
            }
          });
        },
        function() {
          // 成功時
          _this.showSuccess(result)
          _this.back()
        },
        function() {
          // エラー時
          result.obj.message += '\n\n※判定レポート生成に失敗しました。';
          _this.showSuccess(result)
          _this.back()
        }
      );
    },
    

    clipboardCopy: function(){
      navigator.clipboard.writeText(this.uploadFileName).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
        console.log(err);
      });
    },
    toggleRadio(value) {
      if (this.selectedJudgmentTemplate === value) {
        this.selectedJudgmentTemplate = null
        this.judgmentMemo = ''
      } else {
        this.selectedJudgmentTemplate = value
        this.judgmentMemo = value
      }
    },
    getJudgmentTemplates: function() {
      var excuteApi = this.getJudgmentTemplatesPOST;
      var successCallBack = this.getJudgmentTemplatesPOSTSuccess;
      var errorCallBack = this.getJudgmentTemplatesPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getJudgmentTemplatesPOST: function(client) {
      return client.apis.apiCommon.getJudgmentTemplatesPOST();
    },
    getJudgmentTemplatesPOSTSuccess: function(result) {
      this.judgmentTemplates = result.obj.judgmentTemplateData;
    },
    getJudgmentTemplatesPOSTError: function(result) {
      this.showErrorMessage(result);
    },

    replaceApproval(){
      var elements = document.getElementsByClassName("edit");
      var result = this.selfMadeValidation(elements);
      if(result.isError) {
        this.showErrorMessage(result.msg)
        return
      }
      var messsage = `判定：${this.judgmentResult}<br><br>フリーコメント：${this.judgmentMemo.replace(/\r?\n/g, '<br>')}<br><br>判定内容がが正しいことを確認してください。<br>判定結果を承認してよろしいでしょうか？`;
      this.$dialog.confirm({
        title: "承認確認",
        message: messsage,
        confirmText:"はい",
        cancelText: "いいえ",
        onConfirm: async() => {
          var excuteApi = this.saveForReplaceApprovalPOST;
          var successCallBack = this.saveForReplaceApprovalPOSTSuccess;
          var errorCallBack = this.saveForReplaceApprovalPOSTError;
          // Web Api Call
          this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      });
    },
    saveForReplaceApprovalPOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber,
        resultVersion: this.resultVersion, // バージョン
        judgmentResult: this.judgmentResult, // 判定
        judgmentMemo: this.judgmentMemo, // フリーコメント
        updatingJudgmentDate: true
      });
      return client.apis.externalHolterAnalysis.tempSaveHolterJudgmentResultPOST({
        body:obj
      });
    },
    saveForReplaceApprovalPOSTSuccess: async function(result) {
      var excuteApi = this.setHolterAnalysisResultReplaceApprovePOST;
      var successCallBack = this.setHolterAnalysisResultReplaceApprovePOSTSuccess;
      var errorCallBack = this.setHolterAnalysisResultReplaceApprovePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);

    },
    saveForReplaceApprovalPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    setHolterAnalysisResultReplaceApprovePOST: function(client) {
      return client.apis.internalHolterAnalysis.setHAnalysisResultReplaceApprovePOST({
        body:{
          receiptNumber: this.data.receiptNumber,
          version: this.version
        }
      });
    },
    setHolterAnalysisResultReplaceApprovePOSTSuccess: function(result) {
      this.generateKanjaReportPDF(result)
    },
    setHolterAnalysisResultReplaceApprovePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
  },
  data() {
    var analysisMethodList = this.getChoiceList(choicesType.holterMethod, true);
    var analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, true);
    var item = this.$route.params["item"];
    var receiptNumber = item.receiptNumber;
    var analysisMethod = item.analysisMethod;
    var paramsResultVersion = item.resultVersion;
    var searchParams = this.$route.params["searchConditions"];
    var detailData = {fileInfo:{}};
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = "";
    var judgmentCompletedStatus = [requestStatus.resultSendReady,
    requestStatus.completion,
    requestStatus.salesAppropriation,
    requestStatus.completionAppropriation
    ]
    if(userInfo){
      var roleId = userInfo.roleId;
    }
    return {
      data: [],
      receiptNumber,
      detailData,
      searchParams,
      upFiles: [],
      analysisMethod,
      paramsResultVersion,
      dismissalReasonInputModalActive:false,
      cancelReasonInputModalActive:false,
      hasDetailData: false,
      resultFiles:[],
      UploadType:UploadType,
      isUpdateModal:false,
      upButtonFile:null,
      judgmentCompletedStatus,
      version: null,
      resultVersion: null,
      analysisMethodList: analysisMethodList,
      analysisOptionList: analysisOptionList,
      atLaunchHidden: atLaunchHidden,
      uploadFileName:"",
      role: role,
      roleId: roleId,
      isCvhriNotCalcCheck: false,
      judgmentResult: "",
      judgmentMemo: "",
      judgmentTemplates: [],
      selectedJudgmentTemplate: null,
      status: null,
      fileReplaceFlag: false,
      isInitialCheckDone: false
    };
  },
  filters: {
    choiceFilter: function(val, list){
      if(!val) return val
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    holterAnalysisRequestDetail: holterAnalysisRequestDetail,
    reasonInputModal:reasonInputModal,
  },
  mounted: function() {
    // 解析結果承認詳細取得
    this.getReceptionData()
    // 申込内容取得
    this.getDetail()
    // 判定結果選択肢取得
    this.getJudgmentTemplates()

    this.getRequestDetailFiles();
  },
  
  watch: {
    judgmentResult() {
      this.selectedJudgmentTemplate = null;
    }
  }
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
.reject-reason-table {
  border-collapse: collapse;
  table-layout: fixed;
}
.reject-reason-table th {
  padding: 1px 0;
  border: 1px solid;
  text-align: center;
  vertical-align: middle;
}
.reject-reason-table td {
  padding: 1px 0 1px 10px;
  border: 1px solid;
  vertical-align: middle;
}
.reject-reason-table th.reject-date,
.reject-reason-table td.reject-date {
  width: 20% !important;
}
a {
  text-decoration: underline;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.clipbordcopy {
  margin-left:3%;
  right: 10px;
  width: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/guest/HolterAnalysisJudgmentDetail.vue